import React, { useState, useEffect, useContext } from "react";
import { Button } from "@mui/material";
import AddStoreDialog from "../../component/management/AddStoreDialog";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useTheme } from "@mui/material/styles";
import getAllStore from "../../api/store/getAllStore";
import {
  DataGrid,
  zhTW,
  GridToolbarContainer,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { AuthContext } from "../../context/AuthContext";
function StorePage() {
  const [open, setOpen] = useState(false);
  const [stores, setStores] = useState([]); // Initialize with your store data
  const [selectedStore, setSelectedStore] = useState({});
  const theme = useTheme();
  const [isAdd, setIsAdd] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const userContext = useContext(AuthContext);
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getAllStore();
        setStores(data.stores);
      } catch (err) {
        setError(err.message);
      }
    };

    if (stores) {
      fetchStores();
    }
  }, []);

  function EditToolbar() {
    const handleClick = () => {
      setIsAdd(true);
      setOpen(true);
    };

    return (
      <GridToolbarContainer>
        <Button color="info" startIcon={<AddIcon />} onClick={handleClick}>
          新增店家
        </Button>
      </GridToolbarContainer>
    );
  }

  const handleEditClick = (id) => () => {
    setIsAdd(false);

    setSelectedStore(stores.find((store) => store.Code === id));
    setOpen(true);
  };

  const columns = [
    {
      field: "操作",
      type: "actions",
      headerName: "操作",
      width: 70,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    { field: "Code", headerName: "店號", width: 100 },
    { field: "Name", headerName: "名稱", width: 130 },
    { field: "City", headerName: "城市", width: 130 },
    { field: "Address", headerName: "地址", width: 130 },
    { field: "Status", headerName: "狀態", width: 130 },
    { field: "Phone", headerName: "電話", width: 130 },
    {
      field: "IsValid",
      headerName: "有效",
      type: "bool",
      width: 110,
    },
  ];

  return (
    <>
      <div style={{ height: 600, width: "100%" }}>
        <DataGrid
          localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
          rows={stores || []}
          columns={columns}
          disableColumnSelector
          disableRowSelectionOnClick
          sx={{ color: theme.palette.text.primary }}
          getRowId={(row) => row.Code}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: {},
          }}
          pageSizeOptions={[10, 20]}
        />
      </div>
      <AddStoreDialog
        isAdd={isAdd}
        store={selectedStore}
        open={open}
        setOpen={setOpen}
      ></AddStoreDialog>
    </>
  );
}

export default StorePage;
